import React from 'react'
import StrikeHeading from '../stike-heading'
import { useStaticQuery, graphql } from 'gatsby'
import { Section } from '../styled'
import { css } from '@emotion/core'
import { MEDIA_QUERY } from '../../constants'

const styles = {
  list: css`
    margin: 0;
    padding: 0;
  `,
  listItem: css`
    list-style: none;
    font-size: 14px;
    line-height: 20px;
    font-family: relativefaux;
    &:last-of-type {
      padding-top: 8px;
    }
  `,
  subList: css`
    margin: 0 0 0 -4px;
    padding: 8px 0 0 0;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  `,
  subListItem: css`
    list-style: none;
    flex: 1 0 50%;
    ${MEDIA_QUERY.aboveSm} {
      flex: 1 0 33.33%;
    }
  `,
  subListItemContent: css`
    position: relative;
    padding: 0 13px;
    &:before, &:after {
      content: '...';
      position: absolute;
      top: -4px;
    }
    &:before {
      left: 0;
    }
    &:after {
      right: 0;
    }
  `
}

const Services = () => {
  const data = useStaticQuery(graphql`
    query {
      allServicesJson {
        nodes {
          description,
          items,
        }
      }
    }
  `)

  return (
    <Section>
      <StrikeHeading heading="Services" />
      <ul css={styles.list}>
        { 
          data.allServicesJson.nodes.map(({ description, items }) => (
            <li css={styles.listItem}>
              { description }
              { items &&  
                <ul css={styles.subList}>
                  {
                    items.map(item => (
                      <li css={styles.subListItem}>
                        <span css={styles.subListItemContent}>{item}</span>
                      </li>
                    )) 
                  }
                </ul>
              }
            </li>
          ))
        }
      </ul>
    </Section>
  )
}

export default Services